module.exports = __webpack_public_path__ + "img/nodeType6.3a080cdf.svg";